import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getBaseUrl } from "../../service/apiUrl";
export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});


const getHorseFutureEntriesSlice = createSlice({
    name: 'fututreentries',
    initialState: {
        data: [],
        status: STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchHorseFutureEntries.pending, (state, action) => {
                state.status = STATUSES.LOADING;
            })
            .addCase(fetchHorseFutureEntries.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = STATUSES.IDLE
            })
            .addCase(fetchHorseFutureEntries.rejected, (state, action) => {
                state.status = STATUSES.ERROR;
            })
    }
});

export const { setTrainer, setStatus } = getHorseFutureEntriesSlice.actions;
export default getHorseFutureEntriesSlice.reducer;

export const fetchHorseFutureEntries = createAsyncThunk('/FutureEntries/fetch', async ({ id }) => {
    const res = await axios.get(`${getBaseUrl()}/FutureEntries/${id}`);
    const trainerstatsData = res.data;
    return trainerstatsData.data;
})